import React from 'react';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function ProductPresentation() {
  const features = ['Más de 50 recetas de budines irresistibles', 'Budines clásicos que siempre funcionan', 'Budines marmolados, frutales y especiados', 'Budines ideales para desayuno, merienda o postre', 'Recetas simples con ingredientes fáciles de conseguir', 'Técnicas para lograr budines húmedos y esponjosos'];
  const examples = ['Budín de limón glaseado', 'Budín marmolado perfecto', 'Budín de chocolate húmedo', 'Budín de vainilla clásico', 'Budines con frutas y especias', 'Budines ideales para vender o regalar'];
  const perfectFor = ['Querés preparar budines caseros deliciosos', 'Te gusta cocinar cosas dulces fáciles', 'Querés sorprender a tu familia o amigos', 'Querés empezar a vender budines caseros', 'Querés tener recetas que siempre funcionen'];
  return <section className="py-20 px-4 bg-[#FEF3E2]" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        {/* What's inside */}
        <div className="mb-20" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-[#3D2B1F]" data-id="element-147">
            Dentro de este libro{' '}
            <span className="text-[#D4850A]" data-id="element-148">vas a descubrir:</span>
          </h2>
          <div className="bg-white rounded-3xl p-8 md:p-10 border border-[#D4850A]/20 shadow-lg" data-id="element-149">
            <ul className="space-y-4 mb-8" data-id="element-150">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-4" data-id="element-151">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-152" />
                  <span className="text-lg text-[#3D2B1F]" data-id="element-153">{feature}</span>
                </li>)}
            </ul>
            <p className="text-xl text-center text-[#D4850A] font-medium italic border-t border-[#E8D5C4] pt-6" data-id="element-154">
              Todo explicado paso a paso para que no tengas que adivinar nada.
            </p>
          </div>
        </div>

        {/* Imagine preparing */}
        <div className="mb-20" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-[#3D2B1F]" data-id="element-156">
            Imaginá poder preparar en casa:
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-157">
            {examples.map((example, index) => <div key={index} className="bg-white p-4 rounded-xl border border-[#E8D5C4] flex items-center gap-3 shadow-sm" data-id="element-158">
                <StarIcon className="w-5 h-5 text-[#D4850A] fill-[#D4850A]" data-id="element-159" />
                <span className="text-[#3D2B1F] font-medium" data-id="element-160">{example}</span>
              </div>)}
          </div>
          <p className="text-center text-[#9B8578] mt-6 text-lg" data-id="element-161">
            Todo con recetas simples que siempre salen bien.
          </p>
        </div>

        {/* Perfect for */}
        <div className="mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-[#3D2B1F]" data-id="element-163">
            Este libro es perfecto para vos si:
          </h2>
          <div className="bg-gradient-to-br from-white to-[#FEF3E2] rounded-3xl p-8 md:p-10 border border-[#D4850A]/20 relative overflow-hidden shadow-lg" data-id="element-164">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#D4850A]/5 rounded-full blur-3xl" data-id="element-165"></div>
            <ul className="space-y-5 relative z-10" data-id="element-166">
              {perfectFor.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-167">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-168">
                    <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-169" />
                  </div>
                  <span className="text-lg md:text-xl text-[#3D2B1F] font-medium" data-id="element-170">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-171">
          <Button href="#compra" size="xl" data-id="element-172">
            ¡Sí! Quiero Preparar Budines Perfectos Hoy
          </Button>
        </div>
      </div>
    </section>;
}